/* eslint-disable import/extensions */
import { InsignFrontCookie } from '../../utils/cookie'
import { URI } from '../../utils/common'
import { QueryParam, QUERY_PARAM_TYPE } from '../../utils/variables'

export default class Feature {
  constructor({ namespace, enumKey }) {
    this.namespaceCookie = new InsignFrontCookie({ namespace })
    this.enumKey = enumKey

    window.$i18next.setDefaultNamespace(namespace)
  }

  get queryParam() {
    return QueryParam.getQueryParam(QUERY_PARAM_TYPE[this.enumKey])
  }

  get queryParamWithCookie() {
    return QueryParam.getQueryParamWithCookie(QUERY_PARAM_TYPE[this.enumKey], this.namespaceCookie.getCookie())
  }

  hasResponse() {
    const { response } = this.queryParam
    return !!response
  }

  hasError() {
    const { response, error_code: errorCode, error_name: errorName } = this.queryParam
    return response === 'fail' || !!(errorCode || errorName)
  }

  // eslint-disable-next-line class-methods-use-this
  navigateToUrlWithoutHistory(url) {
    URI.navigateToUrlWithoutHistory(url)
  }

  getRedirectUriByQueryParamWithCookie({ corsList = [] } = {}) {
    const uri = this.queryParamWithCookie.redirect_uri || ''
    // 통합 검증 함수 사용
    const result = URI.validateAndProcessUri(uri, { decrypt: false, corsList })

    if (result.isValid) {
      return result.uri
    }

    // 문제가 있는 경우 로그 기록
    console.warn(`[getRedirectUri] Invalid URI: ${result.message}`)
    // Sentry.withScope((scope) => {
    //   scope.setLevel('warning')
    //   scope.setExtra('uri', uri)
    //   scope.setExtra('message', result.message)
    //   Sentry.captureMessage('[getRedirectUri] Invalid redirect_uri')
    // })

    const defaultUrl = this.localPlatform?.mainUrl || '/'
    return defaultUrl
  }

  redirect(uri = this.queryParam.redirect_uri) {
    this.redirectWithParams(uri)
  }

  redirectWithParams(uri = this.queryParam.redirect_uri, params = '') {
    if (uri) {
      this.namespaceCookie.clearCookie()

      const searchParamStr = QueryParam.getSearchParamStr(params)
      let finalUri = uri

      if (searchParamStr) {
        const appendParams = new URLSearchParams(searchParamStr.replace(/^\?/, ''))
        let cleanUri = uri
        try {
          const url = new URL(uri)
          appendParams.forEach((_, key) => url.searchParams.delete(key))
          cleanUri = url.toString()
        } catch { /* invalid URL, proceed as-is */ }
        const separator = cleanUri.includes('?') ? '&' : '?'
        finalUri = `${cleanUri}${separator}${appendParams.toString()}`
      }

      console.debug(`[${this.enumKey}] redirect to ${finalUri}`)

      this.navigateToUrlWithoutHistory(finalUri)
    } else {
      console.error('redirect_uri is not defined')
    }
  }
}
